import { memo, useContext, useMemo } from "react";
import { buildPortalCustomizationCss } from "./build-portal-customization-css";
import { CustomizationContext } from "./customization-context";

export const PortalCustomizationStyleTag = memo(
  function PortalCustomizationStyleTag() {
    const { customization } = useContext(CustomizationContext);
    const css = useMemo(
      () => (customization ? buildPortalCustomizationCss(customization) : ""),
      [customization],
    );
    if (!css) return null;
    return <style>{css}</style>;
  },
);
